export function updateEmailAddress() {
	// на основе статьи
	// https://css-tricks.com/how-to-safely-share-your-email-address-on-a-website/
	const $emailLink = document.getElementById("js-footer-email");
	if (!$emailLink) return false;

	const encEmail = $emailLink.dataset.email;
	const subject = $emailLink.dataset.subject;
	$emailLink.setAttribute("href", `mailto: ${atob(encEmail)}?subject=${subject}`);
}
